import React from 'react';

const ContactUsForm = () => {
    return(
    <>
    {/*Contact Section*/}
    <section className="section-padding-four contact-section section-padding-all">
      <div className="default-container">
        <div className="row vertical-content-manage clearfix">
          <div className="col-lg-5">
            <div className="contact-info-box mt-3 animated">
              <div className="contact-details-content p-3 mt-3">
                <div className="contact-detail">
                  <h6 className="font-weight-bold">Address</h6>
                  <p className="text-muted mb-0">621 Columbia Rd #38, Magnolia,</p>
                  <p className="text-muted mb-0">AR, 71753</p>
                </div>
              </div>
              <div className="contact-details-content p-3 mt-3">
                <div className="contact-detail">
                  <h6 className="font-weight-bold">Mail</h6>
                  <p className="text-muted mb-0"><a href="mailto:support@example.com">support@example.com</a></p>
                  <p className="text-muted mb-0"><a href="mailto:info@example.com">info@example.com</a></p>
                </div>
              </div>
              <div className="contact-details-content p-3 mt-3">
                <div className="contact-detail">
                  <h6 className="font-weight-bold">Call</h6>
                  <p className="text-muted mb-0"><a href="tel:+1234567890">+123 456 7890</a>,
                    <br /><a href="tel:+1234567890">+123 456 7890</a>.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="business_form_custom mt-3">
              <form id="contact-form" action="/contact.php" name="contact-form" method="POST">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="messages" />
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <input name="name" id="name" type="text" className="form-control" placeholder="Your name..." required />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <input name="email" id="email" type="email" className="form-control" placeholder="Your email..." required />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <input id="subject" name="subject" type="text" className="form-control" placeholder="Your Subject..." required />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <textarea name="comments" id="comments" rows={4} className="form-control" placeholder="Your message..." required defaultValue={""} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className=" form-group">
                      <input type="submit" name="submit" className="btn btn_custom ploting-btn btn-style-two" defaultValue="Send Message" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/*End Contact Section*/}
    </>
    )
}

export default ContactUsForm;